import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.primary.cetaceanBlue;

  return theme.colors.neutral.white;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.cetaceanBlue;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.shade.vividTint5;

  return theme.colors.hues.cetaceanShade3;
};

const outline = ({ $outline, theme }) => {
  if ($outline) return `2px solid ${theme.colors.primary.cetaceanBlue} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.cetaceanBlue;
};

const focusOutline = ({ theme }) => {
  return `4px solid ${theme.colors.shade.vividTint2}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const SecondaryButtonStructure = css`
  color: ${color};
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
